<template>
    <v-carousel
    v-if="blok"
    cycle
    height="500"
    hide-delimiter-background
    show-arrows-on-hover
    v-editable="blok"
  >
    <v-carousel-item
      v-for="(item, i) in blok.images"
      :key="i"
    >
      <v-sheet
        :style="`background-image: url('${item.image}')`"
        height="100%"
        class="bg"
        tile
      >
      <v-container fill-height>
        <v-row
          class="fill-height heroContent"
          align="center"
          justify="start"

        >  
        <v-col cols="9" offset-xl="2" offset-lg="2" sm="6" md="5" lg="4" xl="3" class="text-left pb">
          <h3><img src="@/assets/logo_mini.svg">{{ item.title }}</h3>
          <p>{{ item.description }}</p>
          <v-btn :to="`/${item.link.cached_url}`" v-if="item.hasLink" color="accent" tile depressed large>{{item.linkName}}</v-btn>
          </v-col>
        </v-row>
        </v-container>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: ['blok']
}
</script>

<style lang="scss" scoped>
@import "./HeroGallery.scss";
</style>
